import { createContext } from 'react';

import type { AppTheme, ThemeName, WorkspaceThemeConfiguration } from '@/hooks/useThemeConfig';

type ThemeContextValue = {
    themeName: ThemeName;
    resolvedThemeName: ThemeName;
    setTheme: (name: ThemeName) => void;
    themes: Record<string, AppTheme>;
    registerTheme: (t: AppTheme) => void;
    setWorkspaceThemeConfiguration: (configuration?: WorkspaceThemeConfiguration) => void;
    workspaceThemeConfiguration?: WorkspaceThemeConfiguration;
};

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
